import moment from 'moment';
import { DIRECTION_FLIGHT, DEPARTURE }
  from 'components/components/booking/utils/FlightConstants';
import T from 'components/common/translations/Translate';
import TransHelper from 'components/common/translations/TransHelper'

export default class FlightHelper {
  constructor(flight, locale, flightType) {
    this.locale = locale;
    this.flight = flight;
    this.flightDate = '';
    // TODO
    // this.flightTime = '';
    this.flightTimeFrom = '';
    this.flightTimeTo = '';
    this.from = '';
    this.to = '';
    this.label = '';
    this.flightType = flightType;
    this.setupData();
  }

  trans = (key) => {
    return TransHelper.translate(this.locale, key);
  }

  setupData() {
    this.flightDate = moment(this.flight.flight_date).format("DD.MM.YYYY");

    if (this.flight.direction === DIRECTION_FLIGHT) {
      //from oslo to city
      this.flightTimeFrom = moment(this.flight.flight_date).format("HH:mm");
      this.flightTimeTo =  moment(this.flight.flight_mirror_date).format("HH:mm");
      this.from = this.flight.airport.name;
      this.to = this.flight.city.name;
    } else {
      this.flightTimeFrom = moment(this.flight.flight_mirror_date).format("HH:mm");
      this.flightTimeTo =  moment(this.flight.flight_date).format("HH:mm");
      this.from = this.flight.city.name;
      this.to = this.flight.airport.name;
    }
    if (this.flightType === DEPARTURE) {
      this.label = this.trans('content.flyOut');
    } else {
      this.label = this.trans('content.flyBack');
    }
  }

  getLabel() {
    return this.label;
  }

  getFrom() {
    return this.from;
  }

  getTo() {
    return this.to;
  }

  getFlightDate() {
    return this.flightDate;
  }

  getFlightTimeFrom() {
    return this.flightTimeFrom;
  }

  getFlightTimeTo() {
    return this.flightTimeTo;
  }

  // TODO
  // getFlighTime() {
  //   return this.flightTime;
  // }

  getFlightTimeFromAirport() {
    return this.flightTimeFromAirport;
  }


  getFlightDateAsString(locale) {
    moment.locale(locale);
    return moment(this.flight.flight_date).format("DD MMMM");
  }

}
